import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { CellWrapper, TextCell } from '@/components/table/styles';

interface ClientsAdvisorProps {
  familyName: string;
  advisor?: string;
  onRedirect: () => void;
}

const ClientsAdvisor = ({ familyName, advisor, onRedirect }: ClientsAdvisorProps) => {
  return (
    <CellWrapper flexDirection={'column'}>
      <RedirectTitleCell id="actionCurioText" onClick={onRedirect}>
        {familyName}
      </RedirectTitleCell>
      {!!advisor && <TextCell>{advisor}</TextCell>}
    </CellWrapper>
  );
};

export default ClientsAdvisor;
